import Header from "../header/Header";
import SideBar from "../sidebar/SideBar";
import "../../App.css";
import { useEffect, useState, useRef } from "react";
import { Dropdown, Menu, Modal, Space, message, Spin } from "antd";
import { useQuery } from "@tanstack/react-query";
import { getUserQuoteById } from "../../lib/quotes";
import { generatePDF } from "../shared/pdf/generatePDF";
import { toast } from "react-toastify";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../config/firebase";
// import useNextOrderNumber from "../quoteadmin/updateOrderNo";
import { FormatDate } from "../../lib/dateFormat";
import { PiDotsThreeVerticalBold } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { useMyContext } from "../../context/MyContext";
import { getAlpha2Code } from "../../lib/helper/countryToAphlaCode";
import DashboardLayout from "../layout";
import Loader from "../shared/loader/loader";


import { FaRegEye } from "react-icons/fa";
import dayjs from "dayjs";
import { Loader2 } from "lucide-react";

function Myqoutes() {
  const obj = {
    active: true,
    content: "My Quotes",
  };
  const { user } = useMyContext();

  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState(null);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [pdfLoading, setPdfLoading] = useState({});
  const [pdfUrl, setPdfUrl] = useState(null);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [showLoader, setShowLoader] = useState(true);


  const { data, isLoading, isError, refetch } = useQuery(
    ["userQuotes", user?.uid],
    async () => {
      const res = await getUserQuoteById(user?.uid);
      return res;
    },
    {
      refetchOnWindowFocus: false,
    }
  );

  const navigate = useNavigate();

  const handleClickOutside = (event) => {
    // Implementation remains the same
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleGeneratePdf = async (quote) => {
    setLoadingPdf(true);

    try {
      // const userDocRef = doc(db, 'quotes', id);
      // const userDocSnap = await getDoc(userDocRef);

      // if (userDocSnap.exists()) {
      //   const data = userDocSnap.data();
      //   setFormData(data);
      // } else {
      //   toast.error('Quote data not found');
      // }
      if (quote) {
        const blob = await generatePDF(quote);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${quote.quoteNumber}.pdf`;
        link.click();
      }
      setLoadingPdf(false);
    } catch (error) {
      toast.error("Error fetching Quote data:", error);
      setLoadingPdf(false);
    }
  };

  // const { nextOrderNo } = useNextOrderNumber();

  // const updateStatus = async (id) => {
  //   try {
  //     const userDocRef = doc(db, "quotes", id);
  //     const orderNumberRef = await getDoc(userDocRef);
  //     const quoteData = orderNumberRef.data();

  //     await updateDoc(userDocRef, {
  //       status: "in progress",
  //       orderNumber: nextOrderNo,
  //     });
  //     toast.success("Quotes Status updated successfully!");
  //     window.location.reload();
  //   } catch (error) {
  //     console.error("Error updating status:", error);
  //     toast.error("Error updating status. Please try again later.");
  //   }
  // };

  const declineStatus = async (id) => {
    try {
      const userDocRef = doc(db, "quotes", id);
      await updateDoc(userDocRef, { status: "decline" });
      toast.success("Quotes Status updated successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Error updating status. Please try again later.");
    }
  };

  useEffect(() => {
    if (data) {
      const sortedAndFilteredData = data
        .filter((item) => item.sendStatus === true)
        .sort(
          (a, b) =>
            dayjs(b.creationDate).valueOf() - dayjs(a.creationDate).valueOf()
        );
      setFilteredData(sortedAndFilteredData);
      setShowLoader(false);

    }
  }, [data]);

  const handleViewPdf = async (quote) => {
    try {
      setPdfLoading((prevState) => ({ ...prevState, [quote.id]: true }));

      // Refetch the latest data before generating PDF
      await refetch();

      // Get the latest version of the quote
      const updatedQuote = data.find((q) => q.id === quote.id);

      const pdfBlob = await generatePDF(updatedQuote);
      const url = URL.createObjectURL(pdfBlob);
      setPdfUrl(url);
    } catch (error) {
      toast.error("Error generating PDF:", error);
    } finally {
      setPdfLoading((prevState) => ({ ...prevState, [quote.id]: false }));
    }
  };

  // Clean up object URLs when component unmounts
  useEffect(() => {
    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [pdfUrl]);

  return (
    <>
      {pdfUrl && (
        <Modal
          title="Quotation"
          open={true}
          onCancel={() => setPdfUrl(null)}
          footer={null}
          width="60%"
        >
          <iframe
            src={`${pdfUrl}#toolbar=0`}
            title="Quotation PDF"
            style={{ width: "100%", height: "70vh", border: 0 }}
          ></iframe>
        </Modal>
      )}
      <Modal
        title="Comment"
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <textarea className="w-full h-[100px] border border-gray-300 p-2 rounded-md focus:outline-none" />
        <button className="mt-4 w-[130px] text-white rounded-md h-[40px] bg-blue-700">
          Send
        </button>
      </Modal>
      <DashboardLayout>
        <div className="w-full">
          <Header title="My Quotes" />
          {showLoader ? (
            <Loader />
          ) : (

            <div className="p-4 bg-cus-gray h-full">
              <div className="flex items-center justify-between bg-white rounded-md">
                <div className=" w-full inline">
                  <table className="w-full text-sm text-start ">
                    <thead className="font-normal">
                      <tr className="border-b-2">
                        <th className="p-2">Quote</th>
                        <th className="p-3">Date</th>
                        <th className="p-1">Route</th>
                        <th className="p-1">Quote Request Status</th>
                        <th className="p-1">Action</th>
                      </tr>
                    </thead>
                    {filteredData &&
                      filteredData.map((quote, index) => (
                        <tbody key={index}>
                          <tr className="border-b-2 py-3 text-center">
                            <td className="p-1">{quote.quoteNumber}</td>
                            <td className="p-1">
                              {FormatDate(quote.creationDate)}
                            </td>
                            <td className="p-1">
                              {getAlpha2Code(quote.loadCountry)} -{" "}
                              {getAlpha2Code(quote.unloadCountry)}
                            </td>
                            <td className="p-1 py-2 flex gap-4 items-center justify-center">
                              <button
                                data-tooltip-id="view"
                                onClick={() => handleViewPdf(quote)}
                                className="py-1 px-3 rounded-md bg-[#A9A9A9] text-white disabled:bg-opacity-50"
                                disabled={pdfLoading[quote.id]}
                              >
                                {pdfLoading[quote.id] ? (
                                  <Loader2 className="animate-spin" />
                                ) : (
                                  <FaRegEye className="text-2xl" />
                                )}
                              </button>
                              <div
                                className={`border w-32 rounded-md p-1 py-1 px-4 ${quote.status === "pending"
                                  ? "bg-blue text-white "
                                  : quote.status === "decline"
                                    ? "bg-red-500 text-white"
                                    : "bg-green-500 text-white"
                                  }`}
                              >
                                {quote.status === "pending"
                                  ? "Pending"
                                  : quote.status === "decline"
                                    ? "Rejected"
                                    : "Accepted"}
                              </div>
                            </td>
                            <td className="p-1">
                              <Dropdown
                                menu={{
                                  items: [
                                    {
                                      key: "generatePdf",
                                      label: (
                                        <Space>
                                          {loadingPdf
                                            ? "Downloading pdf ...."
                                            : "Download "}
                                        </Space>
                                      ),
                                      onClick: () => handleGeneratePdf(quote),
                                    },
                                  ],
                                }}
                                open={openDropdownIndex === index}
                                trigger={["click"]}
                                onOpenChange={(visible) => {
                                  setOpenDropdownIndex(visible ? index : null);
                                }}
                              >
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setOpenDropdownIndex(index);
                                  }}
                                >
                                  <Space>
                                    <button className="border p-1 rounded-md border-blue-500">
                                      <PiDotsThreeVerticalBold size={20} />
                                    </button>
                                  </Space>
                                </a>
                              </Dropdown>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </DashboardLayout>
    </>
  );
}

export default Myqoutes;
